{
  "version": 1,
  "asset_id": "89276300-9f39-41b8-8497-0d0fe9ae6380",
  "project_id": "c2d7b0ea-0bba-49e8-a07e-31dd0f457a9a",
  "url": "/__l5e/assets-v1/89276300-9f39-41b8-8497-0d0fe9ae6380/funnels-visitor-types.png",
  "r2_key": "a/v1/c2d7b0ea-0bba-49e8-a07e-31dd0f457a9a/89276300-9f39-41b8-8497-0d0fe9ae6380/funnels-visitor-types.png",
  "original_filename": "funnels-visitor-types.png",
  "size": 168460,
  "content_type": "image/png",
  "created_at": "2026-07-21T14:50:05Z"
}
